// src/pages/produtos/destaqueProdutos/DestaqueProdutoCad.js
import React, { useEffect, useState } from 'react';

import { DestaqueProduto } from '../../../models/produtos/DestaqueProduto';
import { useDestaqueProduto } from '../../../contexts/produtos/DestaqueProdutoContext';
import { useMessage } from '../../../contexts/geral/MessageContext';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import { useFormHandler } from '../../../hooks/useFormHandler';
import Input from '../../../components/input/Input';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import DestaqueProdutoSearch from './DestaqueProdutoSearch';
import ModalActions, { ModalActionButton } from '../../../components/modalForm/ModalActions';

const DestaqueProdutoCad = ({ show, onHide }) => {
    const { destaqueProdutos, addDestaqueProduto, updateDestaqueProduto, deleteDestaqueProduto } = useDestaqueProduto();
    const { showMessage } = useMessage();
    const { showYesNo } = useYesNo();
    const { isSubmitting, handleSubmit } = useFormHandler();
    const [destaqueProduto, setDestaqueProduto] = useState(new DestaqueProduto());
    const [novoReg, setNovoReg] = useState(false);
    const [showSearchModal, setShowSearchModal] = useState(false);

    useEffect(() => {
        if (show) {
            handleNovo();
        }
    }, [show]);

    const handleNovo = () => {
        setDestaqueProduto(new DestaqueProduto());
        setNovoReg(true);
    };

    const handleEditar = (id) => {
        if (id === 0) {
            showMessage('Selecione um destaque de produto para editar!');
            return;
        }

        setNovoReg(false);
    };

    const handleDelete = async () => {
        if (!destaqueProduto?.id) {
            showMessage('Selecione um destaque de produto para excluir!');
            return;
        }

        const resposta = await showYesNo('Deseja excluir o destaque de produto selecionado?');
        if (resposta) {
            await deleteDestaqueProduto(destaqueProduto.id);
            handleNovo();
        }
    };

    const handleSave = () => {
        if (!destaqueProduto.titulo?.trim()) {
            showMessage('Informe um titulo para o destaque de produto!');
            return;
        }

        handleSubmit(
            async () => {
                if (!destaqueProduto.id) {
                    await addDestaqueProduto(destaqueProduto);
                } else {
                    await updateDestaqueProduto(destaqueProduto);
                }

                handleNovo();
            },
            () => {},
            (error) => console.error('Erro ao gravar destaque de produto:', error),
        );
    };

    const handleExit = () => {
        const destaqueSel = destaqueProdutos.find((item) => item.id.toString() === destaqueProduto?.id?.toString());

        if (destaqueSel) {
            setDestaqueProduto(destaqueSel);
            handleEditar(destaqueSel.id);
            return;
        }

        setDestaqueProduto(new DestaqueProduto());
    };

    const handleSelectDestaqueProduto = (item) => {
        setDestaqueProduto(item || new DestaqueProduto());
        setShowSearchModal(false);

        if (item) {
            handleEditar(item.id);
        }
    };

    if (!show) return null;

    return (
        <>
            <ModalContainer show={show} largura="500px" zIndex={1070} variant="cadastro" onHide={onHide}>
                <ModalHeader title={<>{novoReg ? 'Novo Destaque de Produto' : 'Alterar Destaque de Produto'}</>} onHide={onHide} />
                <ModalBody>
                    <form>
                        <div className="input-group mb-3">
                            <Input
                                label="Codigo"
                                value={destaqueProduto.id || ''}
                                onChange={(e) => setDestaqueProduto({ ...destaqueProduto, id: e.target.value })}
                                onBlur={handleExit}
                                disabled={!novoReg}
                                btnBuscar={() => setShowSearchModal(true)}
                            />
                            <Input
                                label="Titulo"
                                value={destaqueProduto.titulo || ''}
                                onChange={(e) => setDestaqueProduto({ ...destaqueProduto, titulo: e.target.value })}
                                size={250}
                                autoFocus
                            />
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <ModalActions >
                        <ModalActionButton
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSave}
                            disabled={isSubmitting}
                         action="save">
                            {isSubmitting ? 'Salvando...' : 'Salvar'}
                        </ModalActionButton>
                        <ModalActionButton
                            type="button"
                            className="btn btn-danger"
                            onClick={handleDelete}
                            disabled={novoReg}
                         action="delete">
                            Excluir
                        </ModalActionButton>
                        <ModalActionButton
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleNovo}
                            disabled={novoReg}
                         action="new">
                            Novo
                        </ModalActionButton>
                    </ModalActions>
                </ModalFooter>
            </ModalContainer>

            <DestaqueProdutoSearch
                show={showSearchModal}
                onHide={() => setShowSearchModal(false)}
                onSelectDestaqueProduto={handleSelectDestaqueProduto}
            />
        </>
    );
};

export default DestaqueProdutoCad;
